import { Injectable } from "@angular/core";
import { IonRouterOutlet } from "@ionic/angular";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class IosGestureService {
  private outlet: IonRouterOutlet | null = null;
  private router: Router | null = null;
  private readonly defaultRoutesWithoutSwipe: string[] = [
    '/checkout',
    '/auth/otp',
    '/profil/editer',
    '/services-around',
  ];
  private routesWithoutSwipe = new Set<string>(this.defaultRoutesWithoutSwipe);
  private manualDisableCount = 0;

  registerOutlet(outlet?: IonRouterOutlet | null): void {
    if (outlet) {
      this.outlet = outlet;
    }
  }

  unregisterOutlet(): void {
    this.outlet = null;
  }

  setSwipeEnabled(enabled: boolean): void {
    if (this.outlet) {
      this.outlet.swipeGesture = enabled;
 
    }
  }

  disableSwipeBack(): void {
    this.manualDisableCount++;
    this.setSwipeEnabled(false);
  }

  enableSwipeBack(): void {
    if (this.manualDisableCount > 0) {
      this.manualDisableCount--;
    }
    if (this.manualDisableCount === 0) {
      // If a router is registered, re-apply the rule based on current URL
      const currentUrl = this.router?.url?.split('?')[0] || '';
      if (currentUrl) {
        this.applySwipeRuleForUrl(currentUrl);
      } else {
        this.setSwipeEnabled(true);
      }
    }
  }

  // ---------- Route-based rules ----------
  registerRouter(router: Router): void {
    this.router = router;
    router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((evt: NavigationEnd) => {
        if (this.manualDisableCount === 0) {
          this.applySwipeRuleForUrl(evt.urlAfterRedirects.split('?')[0]);
        }
      });
  }

  setRoutesWithoutSwipe(routes: string[] = this.defaultRoutesWithoutSwipe): void {
    this.routesWithoutSwipe = new Set(routes);
    const currentUrl = this.router?.url?.split('?')[0] || '';
    if (currentUrl && this.manualDisableCount === 0) {
      this.applySwipeRuleForUrl(currentUrl);
    }
  }

  addRoutesWithoutSwipe(...routes: string[]): void {
    routes.forEach((r) => this.routesWithoutSwipe.add(r));
    const currentUrl = this.router?.url?.split('?')[0] || '';
    if (currentUrl && this.manualDisableCount === 0) {
      this.applySwipeRuleForUrl(currentUrl);
    }
  }

  removeRouteWithoutSwipe(route: string): void {
    this.routesWithoutSwipe.delete(route);
    const currentUrl = this.router?.url?.split('?')[0] || '';
    if (currentUrl && this.manualDisableCount === 0) {
      this.applySwipeRuleForUrl(currentUrl);
    }
  }

  resetRoutesWithoutSwipeToDefault(): void {
    this.setRoutesWithoutSwipe(this.defaultRoutesWithoutSwipe);
  }

  getRoutesWithoutSwipe(): string[] {
    return Array.from(this.routesWithoutSwipe);
  }

  isRouteSwipeDisabled(url: string): boolean {
    const clean = url.split('?')[0];
    return this.routesWithoutSwipe.has(clean);
  }

  private applySwipeRuleForUrl(url: string): void {
    if (!this.outlet) return;
    const disable = this.isRouteSwipeDisabled(url);
    this.setSwipeEnabled(!disable);
  }
}


